import gql from 'graphql-tag';

const createPublicProjectMutation = gql`
  mutation createVideo($organisationId: String!, $input: NewVideoInput!) {
    createVideo(organisationId: $organisationId, input: $input) {
      videoId
      organisationId
      submittedTimezone
      workflowVersion
      projectConfig {
        isAIComposeEnabled
      }
    }
  }
`;

export type MetaDataInput = {
  description?: string;
  keywords?: string;
  tone?: string;
  duration?: string;
  url?: string;
};

export type ToolConfigInput = {
  type?: string;
  status?: string;
  metaData?: MetaDataInput;
};

export type ProjectConfigInput = {
  isAIComposeEnabled?: boolean;
  toolsConfig?: ToolConfigInput[];
};

const createPublicProject = (organisationId?: string) => ({
  mutation: createPublicProjectMutation,
  module: 'video',
  buildVariables: ({
    publicProjectId,
    submittedTimezone,
    workflowVersion
  }: {
    publicProjectId: string;
    submittedTimezone: string;
    workflowVersion?: number;
  }) => ({
    organisationId,
    input: {
      name: 'Imported Project',
      projectType: 'VIDEO',
      submittedTimezone,
      workflowVersion,
      publicProjectId
    }
  })
});

export default createPublicProject;
